import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const TypographyStyled = styled(Typography)`
  display: block;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 16px;
  min-height: 16px;
  line-height: 16px;
  font-size: 14px;
  color: #777;
`

const SubText = ({
  text,
  classes,
  theme,
  ...other
}) => {

  return (
    <TypographyStyled {...other} variant="subheading">
      {text}
    </TypographyStyled>
  )
}

SubText.propTypes = {
  text: PropTypes.string,
};

SubText.defaultProps = {

};

export default SubText;
